import { decodePrivilegeBits, isSuperAdminUsername } from '@/constants/privileges';

/**
 * @see https://umijs.org/docs/max/access#access
 * */
export default function access(initialState: { currentUser?: API.CurrentUser } | undefined) {
  const { currentUser } = initialState ?? {};
  const isAdmin = isSuperAdminUsername(currentUser?.username);
  const legacyPrivileges = Array.isArray((currentUser as { privileges?: string[] } | undefined)?.privileges)
    ? ((currentUser as { privileges?: API.UserPrivilege[] }).privileges ?? [])
    : [];
  const privilegeSet = new Set<API.UserPrivilege>([
    ...decodePrivilegeBits(currentUser?.privilege),
    ...legacyPrivileges,
  ]);

  return {
    canAdmin: isAdmin,
    canEditSiteSetting: privilegeSet.has('edit-site-setting') || isAdmin,
    canManageRecommendation: privilegeSet.has('manage-recommendation') || isAdmin,
    canEditGalleryDetailAds: privilegeSet.has('edit-gallery-detail-ads') || isAdmin,
    canManageFrontendUsers: privilegeSet.has('manage-frontend-users') || isAdmin,
    canManageUserPosts: privilegeSet.has('manage-user-posts') || isAdmin,
    canManageUserComments: privilegeSet.has('manage-user-comments') || isAdmin,
  };
}
